import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { usePromo } from "../Context/PromoContext";
 
export default function CouponScrollBar({ setPaddingClass }) {
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const location = useLocation();
  const [promoText, setPromoText] = useState("");
  const { promoMessages, loading } = usePromo();
 
  useEffect(() => {
    if (loading) return;

    const currentPage = location.pathname.replace("/", "");

    const matched = promoMessages.find(
      (item) => item.pageName === currentPage
    );

    if (matched) {
      setPromoText(matched.promoMessage);
      setPaddingClass(true);
    } else {
      setPromoText("");
      setPaddingClass(false);
    }
  }, [location.pathname, promoMessages, loading, setPaddingClass]);
 
  useEffect(() => {
    const text = textRef.current;
    const container = containerRef.current;
 
    if (text && container) {
      const textWidth = text.scrollWidth;
      const containerWidth = container.offsetWidth;
      const width = window.innerWidth;
      let speed;
      if (width < 600) {
        speed = 70; // px per second
      } else {
        speed = 150; // px per second
      }
      const distance = textWidth + containerWidth;
      const duration = distance / speed;
 
      text.style.animationDuration = `${duration}s`;
    }
  }, [promoText]);
 
  // If no promo text is available, don't render the scrollable message
  if (!promoText) return null;
 
  return (
    <div className="back-color">
      <div className="scroll-container" ref={containerRef}>
        <div className="scroll-text td-text-slider-item" ref={textRef}>
          <img src="images/promo-img-1.png" alt="round" />
          {promoText}
          <img src="images/promo-img-1.png" alt="round" />
        </div>
      </div>
    </div>
  );
}
